/* ═══════════════════════════════════════════════
   KITSUNE MERCHANT — Main JavaScript
   ═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {

  // ── SAKURA PETALS ──
  
  const petalContainer = document.getElementById('petals');
  if (petalContainer) {
    for (let i = 0; i < 18; i++) {
      const p = document.createElement('div');
      p.className = 'petal';
      
      p.style.left = Math.random() * 100 + 'vw';
      p.style.animationDuration = (8 + Math.random() * 10) + 's';
      p.style.animationDelay = (Math.random() * 12) + 's';
      p.style.fontSize = (10 + Math.random() * 8) + 'px';
      petalContainer.appendChild(p);
    }
  }

  // ── BACK TO TOP ──
  const backTop = document.getElementById('backTop');
  if (backTop) {
    window.addEventListener('scroll', () => {
      backTop.classList.toggle('visible', window.scrollY > 400);
    });
  }

  // ── VARIANT SELECTION (Product page) ──
  const optionBtns = document.querySelectorAll('.option-btn');
  optionBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const optionPos = this.dataset.option;
      document.querySelectorAll(`[data-option="${optionPos}"]`).forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      updateVariant();
    });
  });

  function updateVariant() {
    // Shopify will handle variant matching via URL params or custom JS
    // This updates the hidden variant input based on selected options
    const selected = {};
    document.querySelectorAll('.option-btn.selected').forEach(btn => {
      selected[btn.dataset.option] = btn.dataset.value;
    });
  }

  // ── QUANTITY ADJUST (Product page) ──
  window.adjustQty = function(delta) {
    const input = document.getElementById('qty');
    if (!input) return;
    const newVal = Math.max(1, parseInt(input.value || 1) + delta);
    input.value = newVal;
  };

  // ── AJAX ADD TO CART ──
  const atcForm = document.getElementById('product-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = document.getElementById('add-to-cart-btn');
      const variantId = document.getElementById('selected-variant').value;
      const qty = document.getElementById('qty').value || 1;

      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
      })
      .then(r => r.json())
      .then(() => {
        btn.textContent = '✓ Added to Cart!';
        btn.style.background = 'linear-gradient(135deg,#1a5c1a,#0d3a0d)';
        updateCartCount();
        setTimeout(() => {
          btn.textContent = 'Add to Cart 🛒';
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      })
      .catch(() => {
        btn.textContent = 'Add to Cart 🛒';
        btn.disabled = false;
      });
    });
  }

  // ── UPDATE CART COUNT IN NAV ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badge = document.getElementById('cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.transform = 'scale(1.4)';
          badge.style.background = '#F2C94C';
          setTimeout(() => {
            badge.style.transform = 'scale(1)';
            badge.style.background = '#D4A017';
          }, 300);
        }
      });
  }

  // Call on load to sync cart count
  updateCartCount();

});

// ── WISHLIST TOGGLE ──
window.wishToggle = function(el) {
  if (el.textContent === '🤍') {
    el.textContent = '❤️';
    el.style.background = 'rgba(181,23,158,0.8)';
  } else {
    el.textContent = '🤍';
    el.style.background = '';
  }
};

// ── CART ADD (from collection/index cards) ──
window.addToCart = function(variantId, btn) {
  if (!variantId || !btn) return;
  btn.textContent = '…';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(() => {
    btn.textContent = '✓';
    btn.style.background = 'linear-gradient(135deg,#1a5c1a,#0d3a0d)';
    // Update cart badge
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const badge = document.getElementById('cart-count');
      if (badge) badge.textContent = cart.item_count;
    });
    setTimeout(() => {
      btn.textContent = 'Add +';
      btn.style.background = '';
      btn.disabled = false;
    }, 1800);
  })
  .catch(() => {
    btn.textContent = 'Add +';
    btn.disabled = false;
  });
};

// CSS-only sparkle petals (no emoji)
(function spawnPetals() {
  const container = document.getElementById('petals');
  if (!container) return;
  container.innerHTML = '';
  for (let i = 0; i < 20; i++) {
    const p = document.createElement('div');
    p.className = 'petal-spark';
    p.style.left = Math.random() * 100 + 'vw';
    p.style.animationDuration = (7 + Math.random() * 10) + 's';
    p.style.animationDelay = (Math.random() * 14) + 's';
    p.style.width = p.style.height = (4 + Math.random() * 6) + 'px';
    p.style.opacity = (0.3 + Math.random() * 0.4).toFixed(2);
    container.appendChild(p);
  }
})();

// ── AUTO PAGE SETUP HELPER ──
// Run this once in your Shopify admin console to create required pages:
// Paste into browser console on your Shopify admin dashboard
/*
KITSUNE_PAGES = [
  { title: "The Mascot", handle: "the-mascot", template_suffix: "mascot" },
  { title: "About Us", handle: "about", template_suffix: "about" },
  { title: "FAQ & Shipping", handle: "faq", template_suffix: "faq" },
  { title: "Contact", handle: "contact", template_suffix: "contact" },
  { title: "Size Guide", handle: "size-guide", template_suffix: "size-guide" }
];
*/
